import CheckFeature from '../checkfeature'
import { Team } from '@/modules/teams/classes'

export default class ChatTranslationsFeature extends CheckFeature {

  hasFeature (): boolean {
    return this.currentTeam?.features?.chatTranslations?.enabled ?? false
  }

  override get description (): string {
    return 'Enables automatic chat translations through Google Translate'
  }

  teamHasFeature (teamId: string): boolean {
    const team = this.teams[teamId]
    return team?.features?.chatTranslations?.enabled ?? false
  }

  assignTeamFeature (team: Partial<Team>, enabled: boolean): void {
    team.features = team.features ?? {}
    team.features.chatTranslations = { enabled }
  }

  isGlobalFeature (): boolean {
    return false
  }
}
